import loadable from '@loadable/component';

const AsyncGlobalAlertContainer = loadable(
    () =>
        import(
            /* webpackChunkName: "global-alert" */
            /* webpackPrefetch: true */
            './GlobalAlertContainer'
        ),
    {ssr: false}
);
export default AsyncGlobalAlertContainer;
